let utils = {
	getRandomString (num) {
		let arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
		let res = ''
		for (let i = 0; i < num; i++) {
			let id = Math.ceil(Math.random() * 61)
			res += arr[id]
		}
		return res
	},
	getNewFileName (num) {
		let fileName = (new Date().toISOString()).replace(/[-|:|-|\.]/g, '')
		return `${fileName}${utils.getRandomString(num)}`
	},
	/**
	 * 判断是否为对象
	 * @param {*} obj
	 */
	isObject (obj) {
		return typeof obj === 'object'
	},
	isNull (obj) {
		return obj === null
	},
	/**
	 * 是否已定义
	 * @param {*} obj 目标对象
	 */
	isDefined (obj) {
		return typeof obj !== 'undefined'
	},
	/**
	 * 是否为数据组类型
	 * @param {*} obj 目标对象
	 */
	isArray (obj) {
		return utils.isDefined(obj) && obj instanceof Array
	},
	/**
	 * 循环方法，可以一致性地执行数据与对象的遍历
	 * @param {*} list 循环对象
	 * @param {*} callback 回调函数
	 */
	each (list, callback) {
		list = list || []
		if (utils.isArray(list)) {
			for (let index = list.length - 1; index >= 0; index--) {
				let result = callback(list[index], index)
				if (result) {
					break
				}
			}
		} else if (utils.isObject(list)) {
			let keys = Object.keys(list)
			for (let key of keys) {
				let result = callback(list[key], key)
				if (result) {
					return
				}
			}
		}
	},
	/**
	 * 深拷贝
	 * @param {*} obj 拷贝对象
	 */
	deepCopy (obj) {
		let newobj
		if (utils.isObject(obj)) {
			newobj = utils.isArray(obj) ? [] : {}
			utils.each(obj, (prop, key) => {
				newobj[key] = utils.isObject(prop) ? utils.deepCopy(prop) : prop
			})
		} else {
			newobj = obj
		}
		return newobj
	},
	/**
	 * 比较两个对象是否完全相等
	 * @param {*} source 源对象
	 * @param {*} target 目标对象
	 */
	equals (source, target) {
		if (source === target) {
			return true
		}

		if (!utils.isObject(source) || !utils.isObject(target)) {
			// 两者有一个不是对象，直接返回两者的比较结果
			return source === target
		} else if (utils.isNull(source) || utils.isNull(target)) {
			// 两者有一个为null，直接返回比较结果
			return source === target
		}
		// 默认相等
		let isEqual = true
		utils.each(source, (propVal, prop) => {
			isEqual = utils.equals(propVal, target[prop])
			return !isEqual //不等直接返回true跳出循环
		})
		if (!isEqual) {
			return false
		}

		utils.each(target, (propVal, prop) => {
			isEqual = utils.equals(propVal, source[prop])
			return !isEqual
		})
		return isEqual
	},

	debounce (fn, wait = 50, immediate) {
		let timer = null
		return function (...args) {
			if (timer) clearTimeout(timer)
			if (immediate && !timer) {
				fn.apply(this, args)
			}
			timer = setTimeout(() => {
				fn.apply(this, args)
			}, wait)
		}
	},
	replaceAll (str, regexp, replacement) {
		// g 执行全局匹配（查找所有匹配而非在找到第一个匹配后停止）。m 执行多行匹配
		return str.replace(new RegExp(regexp, 'gm'), replacement)
	}

}
export default utils
